/* eslint-disable no-console */
import React, { useEffect, useState } from 'react'
import { TrashIcon } from '@heroicons/react/16/solid'
import {
  TextboxSearch,
  TextboxSearchInputType
} from '@splunk-iteng/splunk-shared-components'
// import { Link } from 'react-router-dom'

import { useDeleteUserMutation, useOktaUserQuery } from '../../graphql/graphql'
import { useAccessLevel } from '../../context/AccessLevelContext'
import {
  DEFAULT_CLASS_NAME,
  DIRECT_PROFILE_DELETE
} from '../../constants/constants'

export function OktaProfileDelete() {
  const [deleteUserMutation] = useDeleteUserMutation()
  const [profile, setProfile] = useState({} as any)
  const [deleteTicketNumber, setDeleteTicketNumber] = useState('')
  const [email, setEmail] = useState('')
  const [profileDeleted, setProfileDeleted] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [isError, setIsError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [
    attemptToDeleteRestrictedAccount,
    setAttemptToDeleteRestrictedAccount
  ] = useState(false)
  const { data, error, loading } = useOktaUserQuery({
    variables: { username: email },
    skip: !email
  })
  const { userRoles } = useAccessLevel()
  const canDirectProfileDelete = userRoles.includes(DIRECT_PROFILE_DELETE)
  const handleDeleteProfile = async () => {
    if (!profile || !profile.id || !deleteTicketNumber.length) {
      return
    }
    setSubmitting(true)

    await deleteUserMutation({
      variables: {
        id: profile.id,
        ticketNumber: deleteTicketNumber
      },
      onCompleted: () => {
        setDeleteTicketNumber('')
        setProfileDeleted(true)
      },
      onError: (err) => {
        const message = err.message.search('Must be in email format')
        if (message >= 0) {
          alert('Please provide a value with a valid email format')
        } else {
          alert(err.message)
        }
      }
    })
    setSubmitting(false)
  }

  useEffect(() => {
    setDeleteTicketNumber('')
    setProfileDeleted(false)
    setProfile(data ? data.oktaUserProfile : {})
  }, [data])

  useEffect(() => {
    setIsError(error)
    setProfileDeleted(false)
    setProfile({})
  }, [error])

  useEffect(() => {
    setIsLoading(loading)
  }, [loading])

  useEffect(() => {
    const domain = email?.split('@')[1]
    if (domain?.includes('splunk.com') || domain?.includes('cisco.com')) {
      setAttemptToDeleteRestrictedAccount(true)
    }
  }, [email])

  if (isLoading) {
    return <div className="pt-20">Loading...</div>
  }

  if (submitting) {
    return <div className="pt-20">Deleting user profile...</div>
  }

  if (isError) {
    return <div className="pt-20">{isError.message}</div>
  }

  if (attemptToDeleteRestrictedAccount) {
    return (
      <div className="pt-20">
        You do not have sufficient permissions to delete a Splunk or Cisco
        profile.
      </div>
    )
  }

  if (profileDeleted) {
    return (
      <div className="pt-20">
        {canDirectProfileDelete ? (
          <p>Account for {email} has been successfully deleted.</p>
        ) : (
          <div>
            <p>
              An email has successfully been sent to the user to confirm the
              profile deletion request.
            </p>
            <p>
              Once the user clicks the link in the email, their Splunk.com
              profile will be deleted.
            </p>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="pt-20 relative">
      {!Object.keys(profile).length ? (
        <div>
          <TextboxSearch
            name="email"
            label="Please enter the email address to delete the profile"
            className={`${DEFAULT_CLASS_NAME} w-120 mb-20`}
            style={{ width: '120px' }}
            value={deleteTicketNumber}
            onSubmit={setEmail}
            Icon={TrashIcon}
            trimOnSubmit
            inputType={TextboxSearchInputType.EMAIL}
          />
        </div>
      ) : (
        <div>
          <TextboxSearch
            name="ticketNumber"
            label="Please enter the ticket # to allow profile deletion"
            className={`${DEFAULT_CLASS_NAME} w-120 mb-20`}
            style={{ width: '120px' }}
            value={deleteTicketNumber}
            onChange={(e) => setDeleteTicketNumber(e.target.value)}
            trimOnSubmit
            inputType={TextboxSearchInputType.TICKET_ID}
          />
          <button
            onClick={() => {
              setProfile({})
              setDeleteTicketNumber('')
            }}
            type="button"
            className="btn btn-inline btn-default"
          >
            Cancel
          </button>
          <button
            onClick={handleDeleteProfile}
            type="button"
            className="btn btn-primary ml-10"
          >
            Confirm Delete
          </button>
        </div>
      )}
    </div>
  )
}
